import api, { adminApiPrefix } from './Api';
import {
  Company,
  companyFromResponse,
  companyToUpsertRequest,
} from '../interfaces/Company/Company';

const companyAdminApiPrefix = `${adminApiPrefix}/companies`;

export const createCompany = async (company: Company): Promise<Company> => {
  const response = await api.post(
    companyAdminApiPrefix,
    companyToUpsertRequest(company),
  );

  return companyFromResponse(response.data?.data);
};

export const getCompanies = async (): Promise<Company[]> => {
  const response = await api.get(companyAdminApiPrefix);

  return (response.data?.data ?? []).map((company: any) =>
    companyFromResponse(company),
  );
};

export const getCompany = async (id: number): Promise<Company> => {
  const response = await api.get(`${companyAdminApiPrefix}/${id}`);

  return companyFromResponse(response.data?.data);
};

export const updateCompany = async (company: Company): Promise<Company> => {
  const response = await api.put(
    `${companyAdminApiPrefix}/${company.id}`,
    companyToUpsertRequest(company),
  );

  return companyFromResponse(response.data?.data);
};

export const deleteCompany = async (id: number): Promise<void> =>
  api.delete(`${companyAdminApiPrefix}/${id}`);
